import { createContext, useEffect, useState, ReactNode } from "react"; // Import ReactNode
import axios, { AxiosError } from "axios"; // Import AxiosError for error typing
import { StoreContextType, Product, SampleProduct } from "./types"; // Import the types

// Create the context with a default value of null
export const StoreContext = createContext<StoreContextType | null>(null);

interface ErrorResponse {
  message: string;
}

// Type the props for the context provider component
interface StoreContextProviderProps {
  children: ReactNode; // Typing for children (React elements)
}

const StoreContextProvider = ({ children }: StoreContextProviderProps) => {
  const [cartItems, setCartItems] = useState<{ [variantId: string]: number }>({});
  const [loading, setLoading] = useState(true);
  const url = process.env.REACT_APP_BACKEND_URL || "http://localhost:4000";
  const [token, setToken] = useState<string>("");
  const [food_list, setFoodList] = useState<Product[]>([]);
  const [sample_products_list, setSampleProductsList] = useState<SampleProduct[]>([]);
  const [discountAmount, setDiscountAmount] = useState<number>(0);
    const [couponCode, setCouponCode] = useState<string>("");

  const [coupon, setCoupon] = useState<{ code: string; discountPercent: number } | null>(null);
  
  // Wishlist state - stored in localStorage for non-authenticated users, synced with backend for authenticated users
  const [wishlistItems, setWishlistItems] = useState<string[]>([]);


  // Add item to cart
  // const addToCart = async (itemId: string) => {

  //   console.log(itemId)
  //   setCartItems((prev) => ({
  //     ...prev,
  //     [itemId]: (typeof prev[itemId] === "number" ? prev[itemId] : 0) + 1,
  //   }));

  //   console.log(cartItems)
  //   if (token) {
  //     try {
  //       await axios.post(url + "/api/cart/add", { itemId }, { headers: { Authorization: `Bearer ${token}` } });
  //     } catch (error: unknown) { // Typing error as unknown
  //       if (axios.isAxiosError(error)) { // Type guard to check if it's an AxiosError
  //         handleAuthError(error);
  //       } else {
  //         console.error("Unexpected error:", error);
  //       }
  //     }
  //   }
  // };

  const addToCart = async (variantId: string) => {
    console.log("Adding variant:", variantId);

    setCartItems((prev) => ({
      ...prev,
      [variantId]: (typeof prev[variantId] === "number" ? prev[variantId] : 0) + 1,
    }));

    if (token) {
      try {
        await axios.post(
          url + "/api/cart/add",
          { itemId: variantId }, // Still sending as itemId for backend
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch (error: unknown) {
        if (axios.isAxiosError(error)) {
          handleAuthError(error);
        } else {
          console.error("Unexpected error:", error);
        }
      }
    }
  };

  // Remove item from cart
  // const removeFromCart = async (itemId: string) => {
  //   setCartItems((prev) => ({
  //     ...prev,
  //     [itemId]: Math.max((prev[itemId] || 1) - 1, 0),
  //   }));

  //   if (token) {
  //     try {
  //       await axios.post(url + "/api/cart/remove", { itemId }, { headers: { Authorization: `Bearer ${token}` } });
  //     } catch (error: unknown) { // Typing error as unknown
  //       if (axios.isAxiosError(error)) { // Type guard to check if it's an AxiosError
  //         handleAuthError(error);
  //       } else {
  //         console.error("Unexpected error:", error);
  //       }
  //     }
  //   }
  // };
  const removeFromCart = async (variantId: string) => {
    setCartItems((prev) => ({
      ...prev,
      [variantId]: Math.max((prev[variantId] || 1) - 1, 0),
    }));

    if (token) {
      try {
        await axios.post(
          url + "/api/cart/remove",
          { itemId: variantId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch (error: unknown) {
        if (axios.isAxiosError(error)) {
          handleAuthError(error);
        } else {
          console.error("Unexpected error:", error);
        }
      }
    }
  };

  // Calculate total amount
  // const getTotalAmount = () => {
  //   return Object.keys(cartItems).reduce((total, item) => {

  //     console.log(item)
  //     const itemInfo = food_list.find((product) => parseInt(product.id) === parseInt(item));

  //     return total + (itemInfo ? Number(itemInfo.variants[0].price) * cartItems[item] : 0);
  //   }, 0);
  // };
  const getTotalAmount = () => {
    // return Object.entries(cartItems).reduce((total, [variantId, quantity]) => {
    //   const product = food_list.find((p) =>
    //     p.variants.some((v) => String(v.id) === variantId)
    //   );
    //   if (!product) return total;

    //   const variant = product.variants.find((v) => String(v.id) === variantId);
    //   if (!variant) return total;

    //   const subtotal = total + Number(variant.price) * quantity;

    //   // if (coupon) {
    //   //   const discount = (coupon.discountPercent / 100) * subtotal;
    //   //   return subtotal - discount;
    //   // }
    //   return subtotal - discountAmount;
    // }, 0);
     const subtotal = getSubtotal();
  return subtotal - discountAmount;
  };

  const getSubtotal = () => {
  return Object.entries(cartItems).reduce((total, [variantId, quantity]) => {
    // First try to find in regular products
    let product = food_list.find((p) =>
      p.variants.some((v) => String(v._id) === variantId)
    );
    
    // If not found in regular products, check sample products
    if (!product) {
      product = sample_products_list.find((sp) =>
        sp.variants.some((v) => String(v._id) === variantId)
      ) as any;
    }
    
    if (!product) return total;

    const variant = product.variants.find((v: any) => String(v._id) === variantId);
    if (!variant) return total;

    return total + Number(variant.price) * quantity;
  }, 0);
};

   const applyCoupon = async (code: string) => {
    try {
      const response = await axios.post(`${url}/validate-coupon`, { couponCode:code });
      const data = response.data;

      const subtotal = Object.entries(cartItems).reduce((total, [variantId, quantity]) => {
        // First try to find in regular products
        let product = food_list.find((p) =>
          p.variants.some((v) => String(v._id) === variantId)
        );
        
        // If not found in regular products, check sample products
        if (!product) {
          product = sample_products_list.find((sp) =>
            sp.variants.some((v) => String(v._id) === variantId)
          ) as any;
        }
        
        if (!product) return total;

        const variant = product.variants.find((v: any) => String(v._id) === variantId);
        if (!variant) return total;

        return total + Number(variant.price) * quantity;
      }, 0);

      let discount = 0;

      if (data.discountType === "percentage") {
        discount = (subtotal * data.value) / 100;
      } else if (data.discountType === "fixed_amount") {
        discount = data.value;
      }

      setDiscountAmount(discount);
      setCouponCode(code);
    } catch (error) {
      console.error("Invalid coupon", error);
      setDiscountAmount(0);
      setCouponCode("");
    }
  }

  // Fetch food list
  const fetchFoodList = async () => {
    try {
      setLoading(true);
      const response = await axios.get(url + "/api/food/list");
      setFoodList(response.data.data);
    } catch (error: unknown) { // Typing error as unknown
      if (axios.isAxiosError(error)) { // Type guard to check if it's an AxiosError
        console.error("Error fetching food list:", error);
      } else {
        console.error("Unexpected error:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  // Fetch sample products list
  const fetchSampleProductsList = async () => {
    try {
      const response = await axios.get(url + "/api/sample-products/list");
      setSampleProductsList(response.data.data);
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error fetching sample products list:", error);
      } else {
        console.error("Unexpected error:", error);
      }
    }
  };

  // Load cart data
  const loadCartData = async (token: string) => {
    try {
      const response = await axios.post(url + "/api/cart/get", {}, { headers: { Authorization: `Bearer ${token}` } });
      setCartItems(response.data.cartData);
    } catch (error: unknown) { // Typing error as AxiosError
      if (axios.isAxiosError(error)) { // Type guard to check if it's an AxiosError
        if (error.response?.status === 401) {
          alert("Your session has expired. Please log in again.");
          setToken(""); // Clear the token
          localStorage.removeItem("token"); // Remove token from local storage
        }
      } else {
        console.error("Unexpected error:", error);
      }
    }
  };

  // Load wishlist data from backend
  const loadWishlistData = async (token: string) => {
    try {
      const response = await axios.post(url + "/api/data/wishlist/get", {}, { headers: { Authorization: `Bearer ${token}` } });
      if (response.data.success) {
        setWishlistItems(response.data.wishlist);
      }
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error loading wishlist:", error);
      } else {
        console.error("Unexpected error:", error);
      }
    }
  };

  // Handle authentication errors
  const handleAuthError = (error: AxiosError<ErrorResponse>) => { // Typing error as AxiosError
    if (error.response?.data?.message === "Token is expired") {
      alert("Your session has expired. Please log in again.");
      setToken(""); // Clear the token
      localStorage.removeItem("token"); // Remove token from local storage
    } else {
      console.error("An error occurred:", error);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      await fetchFoodList();
      await fetchSampleProductsList();
      const storedToken = localStorage.getItem("token");
      if (storedToken) {
        setToken(storedToken);
        await loadCartData(storedToken);
        await loadWishlistData(storedToken);
      } else {
        // Load from localStorage for non-authenticated users
        const saved = localStorage.getItem('wishlist');
        if (saved) {
          setWishlistItems(JSON.parse(saved));
        }
      }
    };
    loadData();
  }, []);

  // Watch for token changes to sync wishlist
  useEffect(() => {
    const syncWishlist = async () => {
      if (token) {
        // User just logged in - migrate localStorage wishlist to backend
        const localWishlist = localStorage.getItem('wishlist');
        if (localWishlist) {
          const parsedWishlist = JSON.parse(localWishlist);
          // Sync each item to backend
          for (const productId of parsedWishlist) {
            try {
              await axios.post(
                url + "/api/data/wishlist/add",
                { productId },
                { headers: { Authorization: `Bearer ${token}` } }
              );
            } catch (error) {
              console.error("Error syncing wishlist item:", error);
            }
          }
          // Clear localStorage wishlist after migration
          localStorage.removeItem('wishlist');
        }
        // Load wishlist from backend
        await loadWishlistData(token);
      } else if (wishlistItems.length > 0) {
        // User logged out - save wishlist to localStorage
        localStorage.setItem('wishlist', JSON.stringify(wishlistItems));
      }
    };
    
    syncWishlist();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const clearCart = () => {
    setCartItems({});
  };

  // Wishlist functions
  const addToWishlist = async (productId: string) => {
    // Update local state immediately for better UX
    setWishlistItems(prev => {
      if (!prev.includes(productId)) {
        return [...prev, productId];
      }
      return prev;
    });

    // Sync with backend if user is logged in
    if (token) {
      try {
        await axios.post(
          url + "/api/data/wishlist/add",
          { productId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch (error: unknown) {
        if (axios.isAxiosError(error)) {
          handleAuthError(error);
        } else {
          console.error("Unexpected error:", error);
        }
      }
    } else {
      // Save to localStorage for non-authenticated users
      setWishlistItems(prev => {
        if (!prev.includes(productId)) {
          const newWishlist = [...prev, productId];
          localStorage.setItem('wishlist', JSON.stringify(newWishlist));
          return newWishlist;
        }
        return prev;
      });
    }
  };

  const removeFromWishlist = async (productId: string) => {
    // Update local state immediately for better UX
    setWishlistItems(prev => prev.filter(id => id !== productId));

    // Sync with backend if user is logged in
    if (token) {
      try {
        await axios.post(
          url + "/api/data/wishlist/remove",
          { productId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch (error: unknown) {
        if (axios.isAxiosError(error)) {
          handleAuthError(error);
        } else {
          console.error("Unexpected error:", error);
        }
      }
    } else {
      // Save to localStorage for non-authenticated users
      setWishlistItems(prev => {
        const newWishlist = prev.filter(id => id !== productId);
        localStorage.setItem('wishlist', JSON.stringify(newWishlist));
        return newWishlist;
      });
    }
  };

  const isInWishlist = (productId: string) => {
    return wishlistItems.includes(productId);
  };

  const contextValue: StoreContextType = {
    food_list,
    sample_products_list,
    addToCart,
    cartItems,
    removeFromCart,
    setCartItems,
    getTotalAmount,
    url,
    setToken,
    token,
    clearCart,
    loading,
    coupon,
    setCoupon,
    applyCoupon,
    couponCode,
    discountAmount,
    wishlistItems,
    addToWishlist,
    removeFromWishlist,
    isInWishlist
  };

  return (
    <StoreContext.Provider value={contextValue}>
      {children}
    </StoreContext.Provider>
  );
};

export default StoreContextProvider;
